import styled from '@emotion/styled';

interface MainLeadProps {
  lead: string;
}

export const MainLead: React.FC<MainLeadProps> = ({ lead }) => {
  const firstWord = lead.split(' ')[0];
  const otherWords = lead.substring(firstWord.length);

  return (
    <Lead>
      <FirstWord>{firstWord}</FirstWord>
      {otherWords}
    </Lead>
  );
};

const Lead = styled.p`
  font-family: var(--font-family-graphik);
  font-style: normal;
  font-weight: 500;
  font-size: 109.784px;
  line-height: 86%;
  text-align: center;
  letter-spacing: -0.03em;
  color: var(--colors-green);
`;

const FirstWord = styled.span`
  text-decoration-line: line-through;
`;
